import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/exam-paper.css';
import App from './App';

if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .catch((error) => console.error('Service Worker registration failed:', error));
    });
  } else {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .then((unregistered) => caches.keys()
        .then((cacheNames) => Promise.all(
          cacheNames
            .filter((cacheName) => cacheName.startsWith('deutschlernen-cache-'))
            .map((cacheName) => caches.delete(cacheName))
        ))
        .then(() => {
          if (unregistered.some(Boolean)) window.location.reload();
        }))
      .catch((error) => console.error('Failed to clear the development service worker:', error));
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
